import React, { useEffect, useState } from "react";
import { useAuth } from "../../../contexts/AuthContext";
import axios from "axios";
import { toast } from "react-toastify";

function ChangeCapitan() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [requests, setRequests] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState(null);
  const [showVotingModal, setShowVotingModal] = useState(false); // 👈 جدید
  const [currentRequest, setCurrentRequest] = useState(null); // 👈 جدید
  const [votingLoading, setVotingLoading] = useState(false); // 👈 جدید

  const { apiBaseUrl } = useAuth();

  useEffect(() => {
    fetchChangeCaptainRequests();
  }, []);

  const fetchChangeCaptainRequests = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(
        `${apiBaseUrl}/api/change-captain/admin/teams-status`
      );

      const requestsData = response.data.data || [];
      setRequests(requestsData);

      // اولین تیم رو به صورت پیش‌فرض انتخاب کن
      if (requestsData.length > 0) {
        setSelectedTeamId(requestsData[0].team.id);
      }

      setLoading(false);
    } catch (err) {
      console.error("❌ خطا:", err);
      setError(err.message || "خطا در دریافت اطلاعات");
      setLoading(false);
    }
  };

  const handleStartVoting = async (request) => {
    try {
      setVotingLoading(true);

      const response = await axios.put(
        `${apiBaseUrl}/api/change-captain/admin/${request.id}/start-voting`
      );

      toast.success("رای‌گیری با موفقیت شروع شد!");

      // مودال رو باز کن
      setCurrentRequest(request);
      setShowVotingModal(true);
    } catch (err) {
      console.error("❌ خطا در شروع رای‌گیری:", err);
      toast.error(err.response?.data?.message || "خطا در شروع رای‌گیری");
    } finally {
      setVotingLoading(false);
    }
  };

  const handleRejectVoting = async (request) => {
    try {
      // تأیید گرفتن از ادمین
      if (!window.confirm("آیا از رد این درخواست مطمئن هستید؟")) {
        return;
      }

      setVotingLoading(true);

      const response = await axios.put(
        `${apiBaseUrl}/api/change-captain/admin/${request.id}/reject-voting`
      );

      toast.success("درخواست با موفقیت رد شد!");

      // رفرش کردن لیست
      fetchChangeCaptainRequests();
    } catch (err) {
      console.error("❌ خطا در رد درخواست:", err);
      toast.error(err.response?.data?.message || "خطا در رد درخواست");
    } finally {
      setVotingLoading(false);
    }
  };

  // گروه‌بندی درخواست‌ها بر اساس تیم
  const groupedRequests = requests.reduce((acc, request) => {
    const teamId = request.team.id;
    if (!acc[teamId]) {
      acc[teamId] = {
        team: request.team,
        requests: [],
      };
    }
    acc[teamId].requests.push(request);
    return acc;
  }, {});

  const teams = Object.values(groupedRequests);
  const selectedTeamData = groupedRequests[selectedTeamId];

  return (
    <div className="p-6" style={{ direction: "rtl" }}>
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center"
          style={{ backgroundColor: "#0ea5e9" }}
        >
          <span className="text-white text-xl">🔄</span>
        </div>
        <div>
          <h2 className="text-white text-xl font-bold">
            درخواست‌های تغییر کاپیتان
          </h2>
          <p className="text-gray-400 text-xs">مدیریت درخواست‌های میز گرد</p>
        </div>
      </div>

      {loading ? (
        <div className="py-16 text-center text-gray-300">
          در حال بارگذاری...
        </div>
      ) : error ? (
        <div className="py-6 text-center">
          <div className="text-red-400 mb-3">❌ {error}</div>
          <button
            onClick={fetchChangeCaptainRequests}
            className="px-4 py-2 rounded-xl text-white"
            style={{ backgroundColor: "#0ea5e9" }}
          >
            تلاش مجدد
          </button>
        </div>
      ) : requests.length === 0 ? (
        <div
          className="rounded-xl border p-8 text-center"
          style={{
            backgroundColor: "rgba(17, 24, 39, 0.6)",
            borderColor: "rgba(55, 65, 81, 0.5)",
          }}
        >
          <p className="text-gray-400">هیچ درخواستی یافت نشد.</p>
        </div>
      ) : (
        <>
          {/* Tabs - تیم‌ها */}
          <div className="flex gap-3 mb-6 overflow-x-auto pb-2">
            {teams.map(({ team, requests: teamRequests }) => (
              <button
                key={team.id}
                onClick={() => setSelectedTeamId(team.id)}
                className={`px-6 py-3 rounded-xl transition-all duration-300 flex items-center gap-3 whitespace-nowrap ${
                  selectedTeamId === team.id
                    ? "ring-2"
                    : "opacity-60 hover:opacity-100"
                }`}
                style={{
                  backgroundColor:
                    selectedTeamId === team.id
                      ? `${team.color}20`
                      : "rgba(31, 41, 55, 0.5)",
                  borderColor: team.color,
                  border: `1px solid ${team.color}`,
                  ringColor: team.color,
                }}
              >
                <div
                  className="w-8 h-8 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: `${team.color}40` }}
                >
                  <span style={{ color: team.color }}>👥</span>
                </div>
                <div className="text-right">
                  <div className="text-white font-semibold">{team.name}</div>
                  <div className="text-xs text-gray-400">
                    {teamRequests.length} درخواست
                  </div>
                </div>
              </button>
            ))}
          </div>

          {/* محتوای تب انتخاب شده */}
          {selectedTeamData && (
            <div className="space-y-4">
              {/* اطلاعات تیم */}
              <div
                className="rounded-xl border p-4"
                style={{
                  backgroundColor: "rgba(17, 24, 39, 0.6)",
                  borderColor: selectedTeamData.team.color,
                }}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div
                      className="w-12 h-12 rounded-xl flex items-center justify-center"
                      style={{
                        backgroundColor: `${selectedTeamData.team.color}30`,
                      }}
                    >
                      <span className="text-2xl">🎯</span>
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-lg">
                        {selectedTeamData.team.name}
                      </h3>
                      <p className="text-gray-400 text-sm">
                        کاپیتان فعلی:{" "}
                        {selectedTeamData.team.captain?.first_name}{" "}
                        {selectedTeamData.team.captain?.last_name}
                      </p>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-gray-400 text-xs">اعضا</div>
                    <div className="text-white font-bold">
                      {selectedTeamData.team.members?.length || 0}
                    </div>
                  </div>
                </div>
              </div>

              {/* لیست درخواست‌ها */}
              {selectedTeamData.requests.map((request) => (
                <div
                  key={request.id}
                  className="rounded-xl border p-5"
                  style={{
                    backgroundColor: "rgba(17, 24, 39, 0.6)",
                    borderColor: "rgba(55, 65, 81, 0.5)",
                  }}
                >
                  <div className="flex items-start justify-between gap-4">
                    {/* اطلاعات درخواست‌دهنده */}
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-3">
                        <div
                          className="w-10 h-10 rounded-full flex items-center justify-center"
                          style={{ backgroundColor: "#0ea5e9" }}
                        >
                          <span className="text-white font-bold">
                            {request.initiator.first_name?.[0]}
                          </span>
                        </div>
                        <div>
                          <div className="text-white font-semibold">
                            {request.initiator.first_name}{" "}
                            {request.initiator.last_name}
                          </div>
                          <div className="text-gray-400 text-xs">
                            {request.initiator.email}
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-3 text-sm">
                        <div>
                          <span className="text-gray-400">شماره تماس:</span>
                          <span className="text-white mr-2">
                            {request.initiator.phone_number}
                          </span>
                        </div>
                        <div>
                          <span className="text-gray-400">رتبه:</span>
                          <span className="text-white mr-2">
                            {request.initiator.rank}
                          </span>
                        </div>
                        <div>
                          <span className="text-gray-400">مرحله:</span>
                          <span className="text-white mr-2">
                            {request.stage_id}
                          </span>
                        </div>
                        <div>
                          <span className="text-gray-400">وضعیت:</span>
                          <span
                            className="mr-2 px-2 py-0.5 rounded text-xs"
                            style={{
                              backgroundColor:
                                request.status === "pending"
                                  ? "rgba(251, 146, 60, 0.2)"
                                  : "rgba(16, 185, 129, 0.2)",
                              color:
                                request.status === "pending"
                                  ? "#fb923c"
                                  : "#10b981",
                            }}
                          >
                            {request.status === "pending"
                              ? "در انتظار"
                              : request.status}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* دکمه‌های عملیات */}
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleStartVoting(request)}
                        disabled={votingLoading}
                        className="px-4 py-2 rounded-xl text-white text-sm hover:opacity-90 transition disabled:opacity-50"
                        style={{ backgroundColor: "#10b981" }}
                      >
                        {votingLoading ? "در حال پردازش..." : "✓ تأیید"}
                      </button>

                      {/* 👇 مودال رای‌گیری */}
                      {showVotingModal && currentRequest && (
                        <VotingModal
                          request={currentRequest}
                          onClose={() => {
                            setShowVotingModal(false);
                            setCurrentRequest(null);
                            fetchChangeCaptainRequests(); // رفرش کردن لیست
                          }}
                          apiBaseUrl={apiBaseUrl}
                        />
                      )}

                      <button
                        onClick={() => handleRejectVoting(request)}
                        disabled={votingLoading}
                        className="px-4 py-2 rounded-xl text-white text-sm hover:opacity-90 transition disabled:opacity-50"
                        style={{ backgroundColor: "#ef4444" }}
                      >
                        {votingLoading ? "در حال پردازش..." : "✗ رد"}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

// در انتهای فایل، قبل از export default

function VotingModal({ request, onClose, apiBaseUrl }) {
  const [votes, setVotes] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [votedUsers, setVotedUsers] = useState(new Set()); // 👈 برای track کردن کسایی که رای دادن
  const [endingVoting, setEndingVoting] = useState(false); // 👈 برای loading دکمه پایان

  const teamMembers = request.team.members || [];

  // تنظیم رای برای هر عضو
  const handleVoteChange = (userId, field, value) => {
    setVotes((prev) => ({
      ...prev,
      [userId]: {
        ...prev[userId],
        [field]: value,
      },
    }));
  };

  // ثبت رای یک عضو
  const handleSubmitVote = async (userId) => {
    const vote = votes[userId];

    if (!vote) {
      toast.error("لطفاً نظر عضو را مشخص کنید");
      return;
    }

    if (vote.is_agree === undefined || vote.is_agree === null) {
      toast.error("لطفاً وضعیت موافقت را مشخص کنید");
      return;
    }

    if (!vote.is_agree && !vote.new_captain_id) {
      // مخالف است - OK
    } else if (vote.is_agree && !vote.new_captain_id) {
      toast.error("لطفاً کاپیتان جدید را انتخاب کنید");
      return;
    }

    try {
      setSubmitting(true);

      const payload = {
        is_agree: vote.is_agree,
      };

      if (vote.is_agree && vote.new_captain_id) {
        payload.new_captain_id = vote.new_captain_id;
      }

      const response = await axios.post(
        `${apiBaseUrl}/api/change-captain/admin/${request.id}/user/${userId}/set-vote`,
        payload
      );

      toast.success("رای با موفقیت ثبت شد!");

      // اضافه کردن به لیست رای‌داده‌ها
      setVotedUsers((prev) => new Set([...prev, userId]));
    } catch (err) {
      console.error("❌ خطا در ثبت رای:", err);
      toast.error(err.response?.data?.message || "خطا در ثبت رای");
    } finally {
      setSubmitting(false);
    }
  };

  // تابع پایان رای‌گیری
  const handleEndVoting = async () => {
    try {
      setEndingVoting(true);

      const response = await axios.put(
        `${apiBaseUrl}/api/change-captain/admin/${request.id}/end-voting`
      );

      toast.success("رای‌گیری با موفقیت پایان یافت!");

      // بستن مودال و رفرش
      onClose();
    } catch (err) {
      console.error("❌ خطا در پایان رای‌گیری:", err);
      toast.error(err.response?.data?.message || "خطا در پایان رای‌گیری");
    } finally {
      setEndingVoting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: "rgba(0,0,0,0.85)" }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-4xl max-h-[90vh] rounded-3xl border backdrop-blur-xl overflow-hidden"
        style={{
          backgroundColor: "rgba(17,24,39,0.96)",
          borderColor: "rgba(16,185,129,0.28)",
          boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
          direction: "rtl",
        }}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between p-5 border-b"
          style={{ borderColor: "rgba(55,65,81,0.5)" }}
        >
          <div>
            <h3 className="text-white text-lg font-bold">
              ثبت رای اعضای تیم {request.team.name}
            </h3>
            {/* نمایش تعداد رای‌های ثبت شده */}
            <p className="text-gray-400 text-sm mt-1">
              {votedUsers.size} از {teamMembers.length} نفر رای داده‌اند
            </p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-xl flex items-center justify-center hover:scale-105 transition"
            style={{
              backgroundColor: "rgba(16,185,129,0.15)",
              border: "1px solid rgba(16,185,129,0.25)",
            }}
          >
            <svg
              className="w-6 h-6 text-emerald-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div
          className="p-5 overflow-y-auto"
          style={{ maxHeight: "calc(90vh - 200px)" }}
        >
          <div className="space-y-4">
            {teamMembers.map((member) => {
              const vote = votes[member.user_id] || {};
              const isCaptain = member.role === "captain";
              const hasVoted = votedUsers.has(member.user_id); // چک کردن آیا رای داده

              return (
                <div
                  key={member.user_id}
                  className="rounded-xl border p-4 relative"
                  style={{
                    backgroundColor: hasVoted
                      ? "rgba(16, 185, 129, 0.1)"
                      : "rgba(31, 41, 55, 0.6)",
                    borderColor: hasVoted
                      ? "rgba(16, 185, 129, 0.5)"
                      : "rgba(55, 65, 81, 0.5)",
                  }}
                >
                  {/* بج رای داده شده */}
                  {hasVoted && (
                    <div
                      className="absolute top-3 left-3 px-3 py-1 rounded-lg text-xs font-semibold flex items-center gap-1"
                      style={{
                        backgroundColor: "rgba(16, 185, 129, 0.2)",
                        color: "#10b981",
                      }}
                    >
                      <span>✓</span>
                      <span>رای ثبت شده</span>
                    </div>
                  )}

                  {/* اطلاعات عضو */}
                  <div className="flex items-center gap-3 mb-4">
                    <div
                      className="w-10 h-10 rounded-full flex items-center justify-center"
                      style={{
                        backgroundColor: hasVoted ? "#10b981" : "#0ea5e9",
                      }}
                    >
                      <span className="text-white font-bold">
                        {member.user.first_name?.[0]}
                      </span>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <span className="text-white font-semibold">
                          {member.user.first_name} {member.user.last_name}
                        </span>
                        {isCaptain && (
                          <span
                            className="px-2 py-0.5 rounded text-xs"
                            style={{
                              backgroundColor: "rgba(251, 146, 60, 0.2)",
                              color: "#fb923c",
                            }}
                          >
                            کاپیتان فعلی
                          </span>
                        )}
                      </div>
                      <div className="text-gray-400 text-xs">
                        {member.user.email}
                      </div>
                    </div>
                  </div>

                  {/* فرم رای - فقط اگر هنوز رای نداده */}
                  {!hasVoted && (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* موافق/مخالف */}
                        <div>
                          <label className="text-sm text-gray-300 mb-2 block">
                            وضعیت موافقت
                          </label>
                          <select
                            value={
                              vote.is_agree === undefined
                                ? ""
                                : vote.is_agree.toString()
                            }
                            onChange={(e) =>
                              handleVoteChange(
                                member.user_id,
                                "is_agree",
                                e.target.value === "true"
                              )
                            }
                            className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
                          >
                            <option value="">— انتخاب کنید —</option>
                            <option value="true">✓ موافق</option>
                            <option value="false">✗ مخالف</option>
                          </select>
                        </div>

                        {/* انتخاب کاپیتان جدید (فقط اگر موافق باشد) */}
                        {vote.is_agree && (
                          <div>
                            <label className="text-sm text-gray-300 mb-2 block">
                              انتخاب کاپیتان جدید
                            </label>
                            <select
                              value={vote.new_captain_id || ""}
                              onChange={(e) =>
                                handleVoteChange(
                                  member.user_id,
                                  "new_captain_id",
                                  Number(e.target.value)
                                )
                              }
                              className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
                            >
                              <option value="">— انتخاب کنید —</option>
                              {teamMembers.map((m) => (
                                <option key={m.user_id} value={m.user_id}>
                                  {m.user.first_name} {m.user.last_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>

                      {/* دکمه ثبت */}
                      <div className="mt-4 flex justify-end">
                        <button
                          onClick={() => handleSubmitVote(member.user_id)}
                          disabled={submitting}
                          className="px-4 py-2 rounded-xl text-white text-sm hover:opacity-90 transition disabled:opacity-50"
                          style={{ backgroundColor: "#10b981" }}
                        >
                          {submitting ? "در حال ثبت..." : "ثبت رای این عضو"}
                        </button>
                      </div>
                    </>
                  )}

                  {/* نمایش اطلاعات رای ثبت شده */}
                  {hasVoted && vote.is_agree !== undefined && (
                    <div
                      className="mt-3 pt-3 border-t"
                      style={{ borderColor: "rgba(55, 65, 81, 0.5)" }}
                    >
                      <div className="flex items-center gap-4 text-sm">
                        <div>
                          <span className="text-gray-400">نظر: </span>
                          <span
                            className={
                              vote.is_agree
                                ? "text-emerald-400"
                                : "text-red-400"
                            }
                          >
                            {vote.is_agree ? "✓ موافق" : "✗ مخالف"}
                          </span>
                        </div>
                        {vote.is_agree && vote.new_captain_id && (
                          <div>
                            <span className="text-gray-400">
                              کاپیتان انتخابی:{" "}
                            </span>
                            <span className="text-white">
                              {
                                teamMembers.find(
                                  (m) => m.user_id === vote.new_captain_id
                                )?.user.first_name
                              }{" "}
                              {
                                teamMembers.find(
                                  (m) => m.user_id === vote.new_captain_id
                                )?.user.last_name
                              }
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Footer */}
        <div
          className="p-5 border-t flex justify-between items-center gap-3"
          style={{ borderColor: "rgba(55,65,81,0.5)" }}
        >
          <button
            onClick={onClose}
            className="px-6 py-2 rounded-xl text-white"
            style={{ backgroundColor: "#6b7280" }}
          >
            بستن
          </button>

          {/* دکمه پایان رای‌گیری */}
          <button
            onClick={handleEndVoting}
            disabled={endingVoting || votedUsers.size === 0}
            className="px-6 py-2 rounded-xl text-white font-semibold disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90 transition"
            style={{ backgroundColor: "#ef4444" }}
          >
            {endingVoting ? "در حال پایان..." : "🔚 پایان رای‌گیری"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChangeCapitan;
